const tableRowCountStyle = theme => ({ rowCount: ({ leftAndRightPadding }) => ({ padding: theme.spacing(0, 0, 1, leftAndRightPadding / 16) }) });

export default tableRowCountStyle;
